import { createStyles } from 'antd-style'

/* Styles for the DialogContent component */
export const useStyles = createStyles(({ css, token }) => ({
  iconContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-block: ${token.paddingXS}px;
    font-size: 62px;
  `,

  description: css`
    font-size: ${token.fontSizeSM}px;
    line-height: ${token.lineHeightSM}em;
    color: ${token.colorText};
    text-align: center;
    width: 100%;
    margin: 0;
  `
}))

/* Styles applied via rootClassName to the antd confirm modal */
export const useDialogStyles = createStyles(({ css, token, prefixCls }) => ({
  dialog: css`
    .${prefixCls}-modal-content {
      padding: 0;
      overflow: hidden;
    }

    .${prefixCls}-modal-close {
      top: 8px;
      inset-inline-end: 12px;
      width: 24px;
      height: 24px;
      color: ${token.colorTextSecondary};

      &:hover {
        color: ${token.colorText};
        background: transparent;
      }
    }

    /* Reset paragraph wrapper — antd subtracts icon width even when icon: null */
    .${prefixCls}-modal-confirm-paragraph {
      max-width: 100% !important;
      width: 100%;
    }

    /* Title = header bar */
    .${prefixCls}-modal-confirm-title {
      height: 40px;
      padding: 0 40px 0 ${token.padding}px;
      display: flex !important;
      align-items: center;
      font-size: ${token.fontSize}px;
      font-weight: 600;
      line-height: ${token.lineHeight}em;
      color: ${token.colorText};
      border-bottom: 1px solid ${token.colorBorder};
      overflow: hidden;

      /* Any direct child (Tooltip trigger, span, etc.) must shrink to allow truncation */
      > * {
        min-width: 0;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    /* Content = icon + description */
    .${prefixCls}-modal-confirm-content {
      margin: 0 !important;
      padding: ${token.paddingSM}px ${token.padding}px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${token.padding}px;
    }

    /* Buttons row */
    .${prefixCls}-modal-confirm-btns {
      padding: 0 ${token.padding}px ${token.padding}px;
      margin-top: ${token.padding}px;
      display: flex;
      gap: ${token.paddingXS}px;

      .${prefixCls}-btn {
        flex: 1;
        margin: 0;
      }
    }
  `,

  dialogTitle: css`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  `
}))
